import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import Typography from 'aquilla/core/atoms/Typography';
import { Fonts, Spacings } from '@styles/index';
import Link from '@base/Link/Link';
import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

const BoldP1 = styled(P1)`
  font-weight: ${Fonts.BOLD};
`;

const Wrapper = styled.div`
  grid-column: span 18;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${Spacings.SPACING_4B};
  margin-top: ${Spacings.SPACING_6B};
  align-items: ${({ $isDescriptionPresent }) =>
    $isDescriptionPresent ? 'flex-start' : 'center'};
  scroll-margin-top: 0;
`;

const LinkWrapper = styled.div`
  margin-right: ${Spacings.SPACING_2B};
  margin-top: ${({ $isDescriptionPresent }) =>
    $isDescriptionPresent ? `${Spacings.SPACING_6}` : `${Spacings.SPACING_0B}`};
`;

const Description = styled(Typography)`
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_1B};
`;

const COMBAT_MARGIN_TOP = 64;

const Header = ({ label, description, seeAllHref, isMobile }) => {
  const combat = useRef();

  const { query } = useRouter();
  useEffect(() => {
    if (query.to === 'combat' && combat) {
      const combatTimer = setTimeout(
        () =>
          window.scrollTo({
            behavior: 'smooth',
            top: combat.current.offsetTop + COMBAT_MARGIN_TOP
          }),
        1500
      );
      return () => clearTimeout(combatTimer);
    }
  }, [query.to]);

  return (
    <Wrapper ref={combat} $isDescriptionPresent={!!description}>
      <div>
        <H4>{label}</H4>
        {description && <Description variant="p2">{description}</Description>}
      </div>
      {seeAllHref && !isMobile && (
        <LinkWrapper $isDescriptionPresent={!!description}>
          <Link href={seeAllHref} shallow>
            <BoldP1 color="var(--color-i-green)">SEE ALL</BoldP1>
          </Link>
        </LinkWrapper>
      )}
    </Wrapper>
  );
};

export default Header;

Header.propTypes = {
  label: PropTypes.string.isRequired,
  seeAllHref: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string])
};

Header.defaultProps = {
  seeAllHref: null
};
